// extracted by mini-css-extract-plugin
export default {"menu":"MenuLayout--menu--5e2be6","contentWrapper":"MenuLayout--contentWrapper--72487b","content":"MenuLayout--content--212b19"};